import React, { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../../config/firebase';

export type IntakeMenuCounts = {
  /** Status „neu“ + offene BWA-Uploads (bestehende Ampel) */
  openCount: number;
  /** Noch nicht als Vorabkunde übernommen — unabhängig von Status „neu“ */
  pendingAdoptionCount: number;
};

export function useIntakeMenuCounts(): IntakeMenuCounts {
  const [intakeNeu, setIntakeNeu] = useState(0);
  const [pendingAdoption, setPendingAdoption] = useState(0);
  const [bwaCount, setBwaCount] = useState(0);

  useEffect(() => {
    const unsubIntake = onSnapshot(collection(db, 'neukunden_intake'), (snap) => {
      let neu = 0;
      let pending = 0;
      snap.docs.forEach((d) => {
        const data = d.data() as { status?: string; vorabkundeId?: string | null };
        if (data.status === 'neu') neu += 1;
        if (!data.vorabkundeId) pending += 1;
      });
      setIntakeNeu(neu);
      setPendingAdoption(pending);
    });
    const unsubBwa = onSnapshot(
      collection(db, 'bwa_uploads'),
      (snap) => setBwaCount(snap.size),
      () => setBwaCount(0)
    );
    return () => {
      unsubIntake();
      unsubBwa();
    };
  }, []);

  return {
    openCount: intakeNeu + bwaCount,
    pendingAdoptionCount: pendingAdoption,
  };
}

/** Rückwärtskompatibel: nur Neu + BWA */
export function useOpenIntakeCount(): number {
  return useIntakeMenuCounts().openCount;
}

export const IntakeCountPill: React.FC<{ count: number }> = ({ count }) => {
  if (!count) return null;
  return (
    <span className="min-w-[1.25rem] h-5 px-1.5 rounded-full bg-white text-red-700 text-[10px] font-black flex items-center justify-center">
      {count}
    </span>
  );
};

/** Nicht übernommene Intakes — eigene Farbe, unabhängig von „neu“ */
export const IntakePendingAdoptionPill: React.FC<{ count: number }> = ({ count }) => {
  if (!count) return null;
  return (
    <span
      title={`${count} noch nicht als Vorabkunde übernommen`}
      className="min-w-[1.25rem] h-5 px-1.5 rounded-full bg-amber-400 text-black text-[10px] font-black flex items-center justify-center"
    >
      {count}
    </span>
  );
};
